<template>
  <HeaderBar />
  <section class="carvia-container space-y-6">
    <Tabs v-model="activeTab" :tabs="tabs" query-param="tab" />

    <MediaLibraryTab v-if="activeTab === 'library'" />
    <MediaRotationTab v-else-if="activeTab === 'rotation'" />
  </section>
</template>

<script lang="ts" setup>
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import Tabs, { type TabItem } from '@/components/Tabs.vue';
import MediaLibraryTab from './MediaLibraryTab.vue';
import MediaRotationTab from '@/views/media-rotation/MediaRotationTab.vue';
import { useUiStore } from '@/stores/ui.store';
import { useAbility } from '@casl/vue';
import { computed, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const uiStore = useUiStore();
const { can } = useAbility();

const canManageRotation = computed(() => can('list', 'RotationMedia'));

const tabs = computed<TabItem[]>(() => {
  const items: TabItem[] = [{ title: t('library'), id: 'library' }];
  if (canManageRotation.value) {
    items.push({ title: t('rotation'), id: 'rotation' });
  }
  return items;
});

const activeTab = ref<string>('library');

watchEffect(() => {
  uiStore.setHeaderTitle(t('media'));
});
</script>

<i18n lang="json">
{
  "en": {
    "media": "Media",
    "library": "Library",
    "rotation": "Rotation"
  },
  "de": {
    "media": "Medien",
    "library": "Mediathek",
    "rotation": "Rotation"
  },
  "es": {
    "media": "Medios",
    "library": "Biblioteca",
    "rotation": "Rotación"
  }
}
</i18n>
